import { Card, Row, Col } from "react-bootstrap";
import Div from "components/Div";
import { trimInvalidDate } from './../../../../helpers/api/utils';
import TextLine from "components/TextLine";
import Text from 'components/Text';
import { ICaseHistory } from "pages/companies/types";
import { useMemo } from "react";
import loader from "assets/images/datahub-loader.svg";
import BlurSpan from "components/BlurSpan";
import useGlobalPremiumFlag from "hooks/useGlobalPremiumFlag";

type CaseHistoryDetailsProps = {
  caseHistoryData: ICaseHistory[];
  loadingCaseHistoryData: boolean;
};

const CaseHistoryDetails = ({
  caseHistoryData,
  loadingCaseHistoryData,
}: CaseHistoryDetailsProps) => {
  const isPremium = useGlobalPremiumFlag();
  const sortedCaseHistoryData = useMemo(() => {
    return [...(caseHistoryData ?? [])].sort((a, b) => {
      const dateA = a.caseOpenDate ? new Date(a.caseOpenDate).getTime() : 0;
      const dateB = b.caseOpenDate ? new Date(b.caseOpenDate).getTime() : 0;

      return dateB - dateA;
    });
  }, [caseHistoryData]);

  return (
    <>
      <Card className="bg-light">
        <Card.Body className="bg-light">
          {loadingCaseHistoryData ? (
            <div className="d-flex justify-content-center align-items-center">
              <img src={loader} height={'50px'}/>
            </div>
          ):
          (sortedCaseHistoryData.length > 0 ?
          sortedCaseHistoryData.map((history) => {
            return (
                <Div className="bg-light font-sans-serif mb-4">
                    <Row className="mb-1">
                        <Col xl={4}>
                            <Row>
                                <TextLine
                                    primary="Case Number:"
                                    labelClass="text-dark"
                                    secondary={
                                      isPremium
                                        ? history.caseNumber ?? ""
                                        : <BlurSpan isBlur={true}>{history.caseNumber ?? ""}</BlurSpan>
                                    }
                                    url={isPremium ? history.caseLink : undefined}
                                    isExternalUrl={isPremium}
                                />
                            </Row>
                        </Col>
                        <Col xl={4}>
                            <Row>
                                <TextLine
                                    primary={"Case Title:"}
                                    labelClass="text-dark"
                                    secondary={
                                      isPremium
                                        ? history.caseTitle ?? ""
                                        : <BlurSpan isBlur={true}>{history.caseTitle ?? ""}</BlurSpan>
                                    }
                                />
                            </Row>
                        </Col>
                        <Col></Col>
                    </Row>
                <Row className="mb-1">
                  <Col xl={4}>
                      <Row>
                        <TextLine
                                    primary={"Case Open Date:"}
                                    labelClass="text-dark"
                                    secondary={
                                      isPremium
                                        ? trimInvalidDate(history.caseOpenDate ? history.caseOpenDate.split("T")[0]:"")
                                        : <BlurSpan isBlur={true}>{trimInvalidDate(history.caseOpenDate ? history.caseOpenDate.split("T")[0]:"")}</BlurSpan>
                                    }
                        />
                      </Row>
                  </Col>
                  <Col xl={4}>
                      <>
                        <Row>
                          <TextLine
                                        primary={"Case Close Date:"}
                                        labelClass="text-dark"
                                        secondary={
                                          isPremium
                                            ? trimInvalidDate(history.caseCloseDate ? history.caseCloseDate.split("T")[0] : "")
                                            : <BlurSpan isBlur={true}>{trimInvalidDate(history.caseCloseDate ? history.caseCloseDate.split("T")[0] : "")}</BlurSpan>
                                        }
                          />
                        </Row>
                      </>
                  </Col>
                  <Col></Col>
                    </Row>
                    <Row className="mb-1">
                        <Col xl={4}>
                            <Row>
                                <TextLine
                                    primary="Status:"
                                    labelClass="text-dark"
                                    secondary={
                                      isPremium
                                        ? history.caseStatus ?? ""
                                        : <BlurSpan isBlur={true}>{history.caseStatus ?? ""}</BlurSpan>
                                    }
                                />
                            </Row>
                        </Col>
                        <Col xl={4}>
                            <Row>
                                <TextLine
                                    primary={"Case Desc:"}
                                    labelClass="text-dark"
                                    secondary={
                                      isPremium
                                        ? history.caseType ?? ""
                                        : <BlurSpan isBlur={true}>{history.caseType ?? ""}</BlurSpan>
                                    }
                                />
                            </Row>
                        </Col>
                        <Col></Col>
                    </Row>
                <Row className="mb-1">
                  <Div>
                            <TextLine
                                primary="Note: "
                                labelClass="text-dark"
                                secondary={
                                  isPremium
                                    ? history?.caseNote
                                    : <BlurSpan isBlur={true}>{history?.caseNote}</BlurSpan>
                                }
                            />
                  </Div>
                </Row>
                <hr />
                </Div>
            )}) : <Text className="text-center" variant="subtitle">{"No cases recorded for this license."}</Text>)}
        </Card.Body>
      </Card>
    </>
  );
};

export default CaseHistoryDetails;
